module.exports = __webpack_public_path__ + "static/media/recoms.588b2a4d.png";